import { render, staticRenderFns } from "./ReconciliationPage.vue?vue&type=template&id=0d850a12&scoped=true"
import script from "./ReconciliationPage.vue?vue&type=script&lang=js"
export * from "./ReconciliationPage.vue?vue&type=script&lang=js"
import style0 from "./ReconciliationPage.vue?vue&type=style&index=0&id=0d850a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d850a12",
  null
  
)

export default component.exports